module.exports = __webpack_public_path__ + "img/Badge_Soc1Type2.c6389bc0.svg";